import { render } from "./MSLearningPanel.vue?vue&type=template&id=9dfd4736&scoped=true&ts=true"
import script from "./MSLearningPanel.vue?vue&type=script&lang=ts"
export * from "./MSLearningPanel.vue?vue&type=script&lang=ts"

import "./MSLearningPanel.vue?vue&type=style&index=0&id=9dfd4736&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dfd4736"]])

export default __exports__